import React from 'react'
import Error404Component from '../components/Error404/Error404Component'

const Error404 = () => {
  return (
    <Error404Component />
  )
}

export default Error404